import React from 'react';
import { Container, Content, Title, Section } from './styles';

const PrivacyPolicy: React.FC = () => {
  return (
    <Container>
      <Content>
        <Title>Política de Privacidade – Excursei</Title>

        <Section>
          <h2>1. Informações Coletadas</h2>
          <p>
            Ao utilizar o Excursei, podemos coletar as seguintes informações:
          </p>
          <ul>
            <li>
              <strong>Dados fornecidos pelo usuário:</strong> nome, e-mail,
              telefone, CPF, e, opcionalmente, CNPJ e razão social (em caso de
              cadastro como empresa).
            </li>
            <li>
              <strong>Futuramente:</strong> poderemos coletar dados técnicos
              automaticamente, como tipo de dispositivo e sistema operacional.
            </li>
          </ul>
          <p>
            O Excursei <strong>não utiliza cookies</strong> ou tecnologias
            semelhantes neste momento.
          </p>
        </Section>

        <Section>
          <h2>2. Finalidade do Uso dos Dados</h2>
          <p>Os dados são utilizados para:</p>
          <ul>
            <li>Melhorar a experiência do usuário no aplicativo;</li>
            <li>Enviar notificações push sobre excursões;</li>
            <li>Personalizar a visualização de conteúdos no app;</li>
            <li>Comunicações de marketing, com consentimento do usuário.</li>
          </ul>
        </Section>

        <Section>
          <h2>3. Compartilhamento com Terceiros</h2>
          <p>Os dados podem ser compartilhados apenas com:</p>
          <ul>
            <li>
              <strong>Firebase (Google):</strong> para autenticação e
              armazenamento;
            </li>
            <li>
              <strong>Serviços de notificação push:</strong> para envio de
              alertas e comunicações.
            </li>
          </ul>
          <p>
            Os dados{' '}
            <strong>
              não são vendidos ou repassados para terceiros não essenciais
            </strong>
            .
          </p>
        </Section>

        <Section>
          <h2>4. Armazenamento e Segurança</h2>
          <p>
            Os dados são armazenados de forma segura utilizando o{' '}
            <strong>Firebase</strong>.<br />
            Permanecem armazenados{' '}
            <strong>enquanto o usuário mantiver o uso do aplicativo</strong>.
            <br />
            Utilizamos autenticação e protocolos do Firebase para proteger as
            informações.
          </p>
        </Section>

        <Section>
          <h2>5. Direitos dos Usuários</h2>
          <p>Você pode, a qualquer momento:</p>
          <ul>
            <li>Acessar seus dados;</li>
            <li>Corrigir informações;</li>
            <li>Solicitar exclusão dos seus dados pessoais e conta.</li>
          </ul>
          <p>
            <strong>Canais de contato:</strong>
            <br />
            E-mail:{' '}
            <a href="mailto:excursei.mailer@gmail.com">
              excursei.mailer@gmail.com
            </a>
            <br />
            Formulário de contato: disponível no site oficial do Excursei
          </p>
        </Section>

        <Section>
          <h2>6. Notificações e Comunicações</h2>
          <p>
            Enviamos <strong>notificações push</strong> com informações úteis
            sobre excursões e o uso do app.
            <br />
            Também podemos enviar{' '}
            <strong>e-mails com conteúdos promocionais</strong>.<br />
            Você pode desativar esses envios a qualquer momento, através das
            configurações do aplicativo ou por link de descadastro no e-mail.
          </p>
        </Section>

        <Section>
          <h2>7. Atualizações da Política de Privacidade</h2>
          <p>
            Podemos atualizar esta política periodicamente. Nestes casos, os
            usuários serão avisados por:
          </p>
          <ul>
            <li>Notificação no site oficial do Excursei;</li>
            <li>Push notification no aplicativo;</li>
            <li>E-mail.</li>
          </ul>
        </Section>

        <Section>
          <h2>8. Contato</h2>
          <p>
            Dúvidas sobre esta Política de Privacidade ou sobre o tratamento de
            dados podem ser encaminhadas para:
          </p>
          <p>
            <strong>Patric Pereira de França</strong>
            <br />
            CPF: 404.633.528-90
            <br />
            E-mail:{' '}
            <a href="mailto:excursei.mailer@gmail.com">
              excursei.mailer@gmail.com
            </a>
          </p>
        </Section>
      </Content>
    </Container>
  );
};

export default PrivacyPolicy;
